var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRealtimeChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 30,
    viewBox: "0 0 70 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.23999 27.2639C0.23999 25.3375 1.80162 23.7759 3.72799 23.7759H5.47199C7.39836 23.7759 8.95999 25.3375 8.95999 27.2639V29.8799H0.23999V27.2639Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.448 22.904C12.448 20.9776 14.0096 19.416 15.936 19.416H17.68C19.6064 19.416 21.168 20.9776 21.168 22.904V29.88H12.448V22.904Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.656 12.4399C24.656 10.5135 26.2176 8.9519 28.144 8.9519H29.888C31.8144 8.9519 33.376 10.5135 33.376 12.4399V29.8799H24.656V12.4399Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.864 13.312C36.864 11.3856 38.4256 9.82397 40.352 9.82397H42.096C44.0224 9.82397 45.584 11.3856 45.584 13.312V29.88H36.864V13.312Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.072 3.71993C49.072 1.79356 50.6337 0.231934 52.56 0.231934H54.304C56.2304 0.231934 57.792 1.79356 57.792 3.71993V29.8799H49.072V3.71993Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.28 12.4399C61.28 10.5135 62.8417 8.9519 64.768 8.9519H66.512C68.4384 8.9519 70 10.5135 70 12.4399V29.8799H61.28V12.4399Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRealtimeChart);
export default __webpack_public_path__ + "static/media/ic_realtime_chart.dbeea4a96f032e07c4ea2318620256d6.svg";
export { ForwardRef as ReactComponent };